/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Ship_Ammo_BombInputs */

const ja_calendar_ship_ammo_bomb = /** @type {(inputs: Calendar_Ship_Ammo_BombInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボム`)
};

const en_calendar_ship_ammo_bomb = /** @type {(inputs: Calendar_Ship_Ammo_BombInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BOMB`)
};

/**
* | output |
* | --- |
* | "BOMB" |
*
* @param {Calendar_Ship_Ammo_BombInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_ship_ammo_bomb = /** @type {((inputs?: Calendar_Ship_Ammo_BombInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Ship_Ammo_BombInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_ship_ammo_bomb(inputs)
	return en_calendar_ship_ammo_bomb(inputs)
});